import './style.css';
/* import OSM from 'ol/source/OSM';
import TileLayer from 'ol/layer/Tile'; */
import {Map, View} from 'ol';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import {Circle, Icon, Fill, Stroke, Style, Text} from 'ol/style';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import GeoJSON from 'ol/format/GeoJSON';





var style_Landkreis = new Style({
  fill: new Fill({
    color: 'rgba(255, 255, 255, 0.6)',
  }),
  stroke: new Stroke({
    color: '#000000',
    width: 2,
  }),
  text: new Text({
    font: '14px Calibri,sans-serif',
    fill: new Fill({
      color: '#000',
    })/* ,
    stroke: new Stroke({
      color: '#fff',
      width: 3,
    }) */
  }),
});

/* var style_Staedte = new Style({
  image: new Circle({
    fill: new Fill({color:[0, 0, 0, 0.5]}),
    radius: 3
  }),
  text: new Text({
    font: '12px Calibri,sans-serif',
    fill: new Fill({color: '#000'}), 
    offsetY: 15
    
  })
}); */

var highlightStyle_Landkreise = new Style({
  stroke: new Stroke({
    color: '#f00',
    width: 1,
  }),
  fill: new Fill({
    color: 'rgba(255,0,0,0.1)',
  }),
  text: new Text({
    font: '16px Calibri,sans-serif',
    fill: new Fill({
      color: '#000',
    }),
    stroke: new Stroke({
      color: '#ffffff',
      width: 2,
    }),
  }),
});


var vectorLayer_Landkreise = new VectorLayer({
  source: new VectorSource({
    url: './data/geojson/Landkreise_IHK_Passau.geojson',
    format: new GeoJSON(),
  }), 
  visible: true,
  style: function (feature) {
    return style_Landkreis;
  }
});

var vectorLayer_SchienenRegensburg = new VectorLayer({
  source: new VectorSource({
    url: './data/geojson/Schienen_IHK_Passau.geojson',
    format: new GeoJSON(),
  }), 
  visible: true, 
  style: new Style({
    stroke: new Stroke({
      color: '#A19FD3',
      width: 3,
    })
  })
});

var vectorLayer_Bundesstraßen = new VectorLayer({
  source: new VectorSource({
    url: './data/geojson/Bundesstrassen_IHK_Passau.geojson',
    format: new GeoJSON(),
  }), 
  visible: true, 
  style: new Style({
    stroke: new Stroke({
      color: '#ffff80',
      width: 3,
    })
  })
});

var vectorLayer_Autobahnen = new VectorLayer({
  source: new VectorSource({
    url: './data/geojson/Autobahn_IHK_Passau.geojson',
    format: new GeoJSON(),
  }), 
  visible: true, 
  style: function (feature) {
  
  let style_Autobahnen = new Style({
    stroke: new Stroke({
      color: '#ff944d',
      width: 3,
    }), 
    text: new Text({
      font: '12px Calibri,sans-serif',
      fill: new Fill({
        color: '#000'
      }), 
      text: feature.get('name')
    }),
  })

  return style_Autobahnen;
}

});

var vectorLayer_Flüsse = new VectorLayer({
  source: new VectorSource({
    url: './data/geojson/River_IHK_Passau_220617.geojson',
    format: new GeoJSON(),
  }), 
  visible: true, 
  style:function (feature) {
  
  let style_fluesse = new Style({
    stroke: new Stroke({
      color: '#80b3ff',
      width: 3,
    }), 
    text: new Text({
      font: '12px Calibri,sans-serif',
      fill: new Fill({
        color: '#013ADF'
      }),
      text: feature.get('name')
    })
  });

  return style_fluesse;
}
});

var vectorLayer_Staedte = new VectorLayer({
  source: new VectorSource({
    url: './data/geojson/Staedte_Passau_220623.geojson',
    format: new GeoJSON(),
  }), 
  visible: true, 
  /* declutter: true, */
  style: 

function (feature) {


  let style_Staedte = new Style({
    image: new Circle({
      fill: new Fill({color:[0, 0, 0, 0.5]}),
      radius: 3
    }),
    text: new Text({
      font: '12px Calibri,sans-serif',
      fill: new Fill({color: '#000'}), 
      offsetY: 15, 
      text: feature.get('Name_Staed')
      ,padding: [3, 3, 3, 3]
      
    })
  });


  //style_Staedte.getText().setText(feature.get('Name_Staedte'));
  let zoom = map.getView().getZoom();
  let Staedte_Faktor=feature.get('Faktor');
  let scalefactor;

  if(zoom<10.5)
  Staedte_Faktor>3 ? scalefactor=Staedte_Faktor*0.3 + 0.5 : scalefactor=0 
  else if(zoom>=10.5 && zoom <12.5)
  Staedte_Faktor>1 ? scalefactor=Staedte_Faktor*0.3 + 0.5 : scalefactor=0 
  else
  scalefactor=Staedte_Faktor*0.3 + 0.5;
  
  style_Staedte.getText().setScale(scalefactor);
 style_Staedte.getImage().setRadius(parseInt(Staedte_Faktor) + 1);

  return style_Staedte;
}


});

var vectorLayer_Chemie_Kunststoff = new VectorLayer({
  source: new VectorSource({
    url: './data/geojson/Punkte_Industriestandorte/Chemie_Kunststoff.geojson',
    format: new GeoJSON(),
  }), 
  visible: true, 
  style:
  function (feature) {

    let style_Chemie_Kunststoff = new Style({
      image: new Circle({
        fill: new Fill({color:'#F9B968'}),
        radius: 3, 
        stroke: new Stroke({
          color: '#000000',
          width: 1,
        })
      }),
      text: new Text({
        font: '12px Calibri,sans-serif',
        fill: new Fill({color: '#000'}), 
        offsetY: 15
      })
    });

    let Chemie_Kunststoff_Faktor=feature.get('Faktor');

    style_Chemie_Kunststoff.getImage().setRadius(parseInt(Chemie_Kunststoff_Faktor) + 1);
    return style_Chemie_Kunststoff;
}
});

var vectorLayer_Bergbau = new VectorLayer({
  source: new VectorSource({
    url: './data/geojson/Punkte_Industriestandorte/Bergbau.geojson',
    format: new GeoJSON(),
  }), 
  visible: true, 
  style:
  function (feature) {

    let style_Bergbau = new Style({
      image: new Circle({
        fill: new Fill({color:'#F29100'}),
        radius: 3, 
        stroke: new Stroke({
          color: '#000000',
          width: 1,
        })
      }),
      text: new Text({
        font: '12px Calibri,sans-serif',
        fill: new Fill({color: '#000'}), 
        offsetY: 15
      })
    });
    let Bergbau_Faktor=feature.get('Faktor');
    style_Bergbau.getImage().setRadius(parseInt(Bergbau_Faktor) + 1);
    return style_Bergbau;
}
});

var vectorLayer_Elektronik = new VectorLayer({
  source: new VectorSource({
    url: './data/geojson/Punkte_Industriestandorte/Elektronik.geojson',
    format: new GeoJSON(),
  }), 
  visible: true, 
  style:
  function (feature) {

    let style_Elektronik = new Style({
      image: new Circle({
        fill: new Fill({color:'#009DD3'}),
        radius: 3, 
        stroke: new Stroke({
          color: '#000000',
          width: 1,
        })
      }),
      text: new Text({
        font: '12px Calibri,sans-serif',
        fill: new Fill({color: '#000'}), 
        offsetY: 15
      })
    });
    let Elektronik_Faktor=feature.get('Faktor');
    style_Elektronik.getImage().setRadius(parseInt(Elektronik_Faktor) + 1);
    return style_Elektronik;
}
});


var vectorLayer_Energieerzeugung = new VectorLayer({
  source: new VectorSource({
    url: './data/geojson/Punkte_Industriestandorte/Energieerzeugung.geojson',
    format: new GeoJSON(),
  }), 
  visible: true, 
  style:
  function (feature) {

    let style_Energieerzeugung = new Style({
      image: new Circle({
        fill: new Fill({color:'#FFCE00'}),
        radius: 3, 
        stroke: new Stroke({
          color: '#000000',
          width: 1,
        })
      }),
      text: new Text({
        font: '12px Calibri,sans-serif',
        fill: new Fill({color: '#000'}), 
        offsetY: 15
      })
    });
    let Energieerzeugung_Faktor=feature.get('Faktor');
    style_Energieerzeugung.getImage().setRadius(parseInt(Energieerzeugung_Faktor) + 1);
    return style_Energieerzeugung;
}
});

var vectorLayer_Fahrzeugbau = new VectorLayer({
  source: new VectorSource({
    url: './data/geojson/Punkte_Industriestandorte/Fahrzeugbau.geojson',
    format: new GeoJSON(),
  }), 
  visible: true, 
  style:
  function (feature) {

    let style_Fahrzeugbau = new Style({
      image: new Circle({
        fill: new Fill({color:'#004B88'}),
        radius: 3, 
        stroke: new Stroke({
          color: '#000000',
          width: 1,
        })
      }),
      text: new Text({
        font: '12px Calibri,sans-serif',
        fill: new Fill({color: '#000'}), 
        offsetY: 15
      })
    });
    let Fahrzeugbau_Faktor=feature.get('Faktor');
    style_Fahrzeugbau.getImage().setRadius(parseInt(Fahrzeugbau_Faktor) + 1);
    return style_Fahrzeugbau;
}
});

var vectorLayer_Feinmechanik_und_Optik = new VectorLayer({
  source: new VectorSource({
    url: './data/geojson/Punkte_Industriestandorte/Feinmechanik_und_Optik.geojson',
    format: new GeoJSON(),
  }), 
  visible: true, 
  style:
  function (feature) {

    let style_Feinmechanik_und_Optik = new Style({
      image: new Circle({
        fill: new Fill({color:'#BCE3F9'}),
        radius: 3, 
        stroke: new Stroke({
          color: '#000000',
          width: 1,
        })
      }),
      text: new Text({
        font: '12px Calibri,sans-serif',
        fill: new Fill({color: '#000'}), 
        offsetY: 15
      })
    });
    let Feinmechanik_und_Optik_Faktor=feature.get('Faktor');
    style_Feinmechanik_und_Optik.getImage().setRadius(parseInt(Feinmechanik_und_Optik_Faktor) + 1);
    return style_Feinmechanik_und_Optik;
}
});

var vectorLayer_Glas_Keramik_Porzelan = new VectorLayer({
  source: new VectorSource({
    url: './data/geojson/Punkte_Industriestandorte/Glas_Keramik_Porzelan.geojson',
    format: new GeoJSON(),
  }), 
  visible: true, 
  style:
  function (feature) {

    let style_Glas_Keramik_Porzelan = new Style({
      image: new Circle({
        fill: new Fill({color:'#E30B2E'}),
        radius: 3, 
        stroke: new Stroke({
          color: '#000000',
          width: 1,
        })
      }),
      text: new Text({
        font: '12px Calibri,sans-serif',
        fill: new Fill({color: '#000'}), 
        offsetY: 15
      })
    });
    let Glas_Keramik_Porzelan_Faktor=feature.get('Faktor');
    style_Glas_Keramik_Porzelan.getImage().setRadius(parseInt(Glas_Keramik_Porzelan_Faktor) + 1);
    return style_Glas_Keramik_Porzelan;
}
});

var vectorLayer_Holzgewerbe = new VectorLayer({
  source: new VectorSource({
    url: './data/geojson/Punkte_Industriestandorte/Holzgewerbe.geojson',
    format: new GeoJSON(),
  }), 
  visible: true, 
  style:
  function (feature) {

    let style_Holzgewerbe = new Style({
      image: new Circle({
        fill: new Fill({color:'#A32523'}),
        radius: 3, 
        stroke: new Stroke({
          color: '#000000',
          width: 1,
        })
      }),
      text: new Text({
        font: '12px Calibri,sans-serif',
        fill: new Fill({color: '#000'}), 
        offsetY: 15
      })
    });
    let Holzgewerbe_Faktor=feature.get('Faktor');
    style_Holzgewerbe.getImage().setRadius(parseInt(Holzgewerbe_Faktor) + 1);
    return style_Holzgewerbe;
}
});

var vectorLayer_Maschinenbau = new VectorLayer({
  source: new VectorSource({
    url: './data/geojson/Punkte_Industriestandorte/Maschinenbau.geojson',
    format: new GeoJSON(),
  }), 
  visible: true, 
  style:
  function (feature) {

    let style_Maschinenbau = new Style({
      image: new Circle({
        fill: new Fill({color:'#9E5097'}),
        radius: 3, 
        stroke: new Stroke({
          color: '#000000',
          width: 1,
        })
      }),
      text: new Text({
        font: '12px Calibri,sans-serif',
        fill: new Fill({color: '#000'}), 
        offsetY: 15
      })
    });
    let Maschinenbau_Faktor=feature.get('Faktor');
    style_Maschinenbau.getImage().setRadius(parseInt(Maschinenbau_Faktor) + 1);
    return style_Maschinenbau;
}
});

var vectorLayer_Metall = new VectorLayer({
  source: new VectorSource({
    url: './data/geojson/Punkte_Industriestandorte/Metall.geojson',
    format: new GeoJSON(),
  }), 
  visible: true, 
  style:
  function (feature) {

    let style_Metall = new Style({
      image: new Circle({
        fill: new Fill({color:'#8CC9AD'}),
        radius: 3, 
        stroke: new Stroke({
          color: '#000000',
          width: 1,
        })
      }),
      text: new Text({
        font: '12px Calibri,sans-serif',
        fill: new Fill({color: '#000'}), 
        offsetY: 15
      })
    });
    let Metall_Faktor=feature.get('Faktor');
    style_Metall.getImage().setRadius(parseInt(Metall_Faktor) + 1);
    return style_Metall;
}
});

var vectorLayer_Möbel_Musikinstrumente = new VectorLayer({
  source: new VectorSource({
    url: './data/geojson/Punkte_Industriestandorte/Möbel_Musikinstrumente.geojson',
    format: new GeoJSON(),
  }), 
  visible: true, 
  style:
  function (feature) {

    let style_Möbel_Musikinstrumente = new Style({
      image: new Circle({
        fill: new Fill({color:'#F7C8DF'}),
        radius: 3, 
        stroke: new Stroke({
          color: '#000000',
          width: 1,
        })
      }),
      text: new Text({
        font: '12px Calibri,sans-serif',
        fill: new Fill({color: '#000'}), 
        offsetY: 15
      })
    });
    let Möbel_Musikinstrumente_Faktor=feature.get('Faktor');
    style_Möbel_Musikinstrumente.getImage().setRadius(parseInt(Möbel_Musikinstrumente_Faktor) + 1);
    return style_Möbel_Musikinstrumente;
}
});

var vectorLayer_Nahrungsmittel = new VectorLayer({
  source: new VectorSource({
    url: './data/geojson/Punkte_Industriestandorte/Nahrungsmittel.geojson',
    format: new GeoJSON(),
  }), 
  visible: true, 
  style:
  function (feature) {

    let style_Nahrungsmittel = new Style({
      image: new Circle({
        fill: new Fill({color:'#76B72A'}),
        radius: 3, 
        stroke: new Stroke({
          color: '#000000',
          width: 1,
        })
      }),
      text: new Text({
        font: '12px Calibri,sans-serif',
        fill: new Fill({color: '#000'}), 
        offsetY: 15
      })
    });
    let Nahrungsmittel_Faktor=feature.get('Faktor');
    style_Nahrungsmittel.getImage().setRadius(parseInt(Nahrungsmittel_Faktor) + 1);
    return style_Nahrungsmittel;
}
});

var vectorLayer_Textil_Bekleidung_Leder = new VectorLayer({
  source: new VectorSource({
    url: './data/geojson/Punkte_Industriestandorte/Textil_Bekleidung_Leder.geojson',
    format: new GeoJSON(),
  }), 
  visible: true, 
  style:
  function (feature) {

    let style_Textil_Bekleidung_Leder = new Style({
      image: new Circle({
        fill: new Fill({color:'#D2DDEA'}),
        radius: 3, 
        stroke: new Stroke({
          color: '#000000',
          width: 1,
        })
      }),
      text: new Text({
        font: '12px Calibri,sans-serif',
        fill: new Fill({color: '#000'}), 
        offsetY: 15
      })
    });
    let Textil_Bekleidung_Leder_Faktor=feature.get('Faktor');
    style_Textil_Bekleidung_Leder.getImage().setRadius(parseInt(Textil_Bekleidung_Leder_Faktor) + 1);
    return style_Textil_Bekleidung_Leder;
}
});

var vectorLayer_Druckerei_Vervielfältigung = new VectorLayer({
  source: new VectorSource({
    url: './data/geojson/Punkte_Industriestandorte/Druckerei_Vervielfältigung.geojson',
    format: new GeoJSON(),
  }), 
  visible: true, 
  style:
  function (feature) {

    let style_Druckerei_Vervielfältigung = new Style({
      image: new Circle({
        fill: new Fill({color:'#D2DDEA'}),
        radius: 3, 
        stroke: new Stroke({
          color: '#000000',
          width: 1,
        })
      }),
      text: new Text({
        font: '12px Calibri,sans-serif',
        fill: new Fill({color: '#000'}), 
        offsetY: 15
      })
    });
    let Druckerei_Vervielfältigung_Faktor=feature.get('Faktor');
    style_Druckerei_Vervielfältigung.getImage().setRadius(parseInt(Druckerei_Vervielfältigung_Faktor) + 1);
    return style_Druckerei_Vervielfältigung;
}
});

var vectorLayer_Papier_Pappe = new VectorLayer({
  source: new VectorSource({
    url: './data/geojson/Punkte_Industriestandorte/Papier_Pappe.geojson',
    format: new GeoJSON(),
  }), 
  visible: true, 
  style:
  function (feature) {

    let style_Papier_Pappe = new Style({
      image: new Circle({
        fill: new Fill({color:'#FFF8C7'}),
        radius: 3, 
        stroke: new Stroke({
          color: '#000000',
          width: 1,
        })
      }),
      text: new Text({
        font: '12px Calibri,sans-serif',
        fill: new Fill({color: '#000'}), 
        offsetY: 15
      })
    });
    let Papier_Pappe_Faktor=feature.get('Faktor');
    style_Papier_Pappe.getImage().setRadius(parseInt(Papier_Pappe_Faktor) + 1);
    return style_Papier_Pappe;
}
});

var vectorLayer_Recycling = new VectorLayer({
  source: new VectorSource({
    url: './data/geojson/Punkte_Industriestandorte/Recycling.geojson',
    format: new GeoJSON(),
  }), 
  visible: true, 
  style:
  function (feature) {

    let style_Recycling = new Style({
      image: new Circle({
        fill: new Fill({color:'#575756'}),
        radius: 3, 
        stroke: new Stroke({
          color: '#000000',
          width: 1,
        })
      }),
      text: new Text({
        font: '12px Calibri,sans-serif',
        fill: new Fill({color: '#000'}), 
        offsetY: 15
      })
    });
    let Recycling_Faktor=feature.get('Faktor');
    style_Recycling.getImage().setRadius(parseInt(Recycling_Faktor) + 1);
    return style_Recycling;
}
});


//*************************************************functions************************************************************************************* */


var layernameReference = {"Fahrzeugbau":vectorLayer_Fahrzeugbau, 
                          "Maschinenbau":vectorLayer_Maschinenbau, 
                          "Metall":vectorLayer_Metall, 
                          "Chemie_Kunststoff":vectorLayer_Chemie_Kunststoff, 
                          "Nahrungsmittel":vectorLayer_Nahrungsmittel, 
                          "Elektronik":vectorLayer_Elektronik,
                          "Holzgewerbe":vectorLayer_Holzgewerbe, 
                          "Bergbau":vectorLayer_Bergbau,
                          "Glas_Keramik_Porzelan":vectorLayer_Glas_Keramik_Porzelan, 
                          "Möbel_Musikinstrumente":vectorLayer_Möbel_Musikinstrumente,
                          "Textil_Bekleidung_Leder":vectorLayer_Textil_Bekleidung_Leder,
                          "Feinmechanik_und_Optik":vectorLayer_Feinmechanik_und_Optik,
                          "Papier_Pappe":vectorLayer_Papier_Pappe,
                          "Druckerei_Vervielfältigung":vectorLayer_Druckerei_Vervielfältigung, 
                          "Energieerzeugung":vectorLayer_Energieerzeugung, 
                          "Recycling":vectorLayer_Recycling     
                          };


var map = new Map({
  layers: [ /* new TileLayer({
    source: new OSM(),
  }) , */ vectorLayer_Landkreise, vectorLayer_SchienenRegensburg, vectorLayer_Bundesstraßen, vectorLayer_Autobahnen, vectorLayer_Flüsse, vectorLayer_Staedte],
  target: 'map',
  controls: [],
  view: new View({
    center: [ 1480457.8737592401, 6200000.946234323],
    zoom: 8.9,
  }),
});

var featureOverlay_Landkreise = new VectorLayer({
  source: new VectorSource(),
  map: map,
  style: function (feature) {
    highlightStyle_Landkreise.getText().setText(feature.get('Landkreise_Name'));
    return highlightStyle_Landkreise;
  },
});


/* var LandkreisMapActive = true;
var SwitchButton =document.getElementById("SwitchButtonToggleMapPresentation");
SwitchButton.addEventListener("click", function(){
  console.log("switch button clicked");
  if(LandkreisMapActive)
  {
    LandkreisMapActive=false;  
  }
  else
  {
    LandkreisMapActive=true;
  }
} ); */



/* function addLayer_StaedteMap(x){map.addLayer(window['vectorLayer_' + x.name]);}
function removeLayer_StaedteMap(x){map.removeLayer(window['vectorLayer_' + x.name]);} */

/* document.getElementById("Mobilität").addEventListener("mouseover", function(){map.addLayer(vectorLayer_Mobilität)});
document.getElementById("Mobilität").addEventListener("mouseout", function(){map.removeLayer(vectorLayer_Mobilität)}); */

var Legendnodes = document.getElementsByClassName('OneLegendRow');

for (let i = 0; i < 16; i++)
{
  document.getElementById(Legendnodes[i].id).addEventListener("mouseover", function(){map.addLayer(layernameReference[Legendnodes[i].id])});
  document.getElementById(Legendnodes[i].id).addEventListener("mouseout", function(){map.removeLayer(layernameReference[Legendnodes[i].id])});
}



var highlight_Landkreise, featureID, featureID_old;
var highlight_Staedte;

var displayFeatureInfo = function (pixel) {
  var feature = map.forEachFeatureAtPixel(pixel, function (feature) {
    return feature;
  });

/* if(LandkreisMapActive)
{ */
  if(feature && feature.get('Landkreise_Name')) 
  {
    if (feature !== highlight_Landkreise) {
      featureID=parseInt(feature.get('ID'));
      document.getElementById("Legende_Wertschöpfung").style.display = "block";
      console.log(featureID + '  ' + pointmap.vectorFeatureArray.length+ '  ' + map.getView().getZoom());
      

      if (highlight_Landkreise) {
        featureOverlay_Landkreise.getSource().removeFeature(highlight_Landkreise);
        pointmap.pointmaplayer.getSource().removeFeature(pointmap.vectorFeatureArray[featureID_old]);
      }
      if (feature) {
        featureOverlay_Landkreise.getSource().addFeature(feature);
        pointmap.pointmaplayer.getSource().addFeature(pointmap.vectorFeatureArray[featureID]);
      }
      highlight_Landkreise = feature;
      featureID_old=featureID;
    }
  }
  else if(highlight_Landkreise)
  {
    featureOverlay_Landkreise.getSource().removeFeature(highlight_Landkreise);
    pointmap.pointmaplayer.getSource().removeFeature(pointmap.vectorFeatureArray[featureID_old]);
    document.getElementById("Legende_Wertschöpfung").style.display = "none";
    highlight_Landkreise=0;
  }


};

map.on('pointermove', function (evt) {
  if (evt.dragging) {
    return;
  }
  var pixel = map.getEventPixel(evt.originalEvent);
  displayFeatureInfo(pixel);
});


var pointmap= new Object({
	pointmaplayer: new VectorLayer({
	  source: new VectorSource({
			}), 
	  declutter: true/* ,
	  style: vectorStyle.point('testlabel1') */
	}),
  	
/*   pointCoordinates:{
    'Kelheim':[ 1320155.476909629, 6241078.115924041 ],
    'Amberg':[ 1319543.9806833474, 6351453.184767836 ],
    'Regensburg_Stadt':[ 1348378.9632481702, 6276073.917053634 ],
    'Weiden i.d. OPf.':[ 1352659.4368321416, 6389582.904057119 ],
    'Amberg-Sulzbach':[ 1306415.0347196106, 6364970.180949292 ],
    'Cham':[ 1411325.4373939163, 6314714.374191052 ],
    'Neumarkt i.d. OPf.':[ 1290554.9327033379, 6311656.893059645 ],
    'Neustadt a.d. Waldnaab':[ 1351322.3701900535, 6402081.897521009 ],
    'Regensburg':[ 1365434.879210819, 6267317.83265593 ],
    'Schwandorf':[ 1362606.7091642672, 6335805.409999448 ],
    'Tirschenreuth':[ 1363371.079447119, 6433033.309978191 ]
  }, */

  /* 'Kelheim':[1460206.0583991178, 6250170.162780169 ], */


  pointCoordinates:{
    'xx':[], 
    'Stadt Landshut':[ 1355732.0, 6186412.488037395],
    'Stadt Passau':[ 1479424.8372432059, 6220231.553488846],
    'Stadt Straubing':[ 1405362.033814376, 6251228.564072734 ],
    'Landkreis Deggendorf':[ 1387487.0407486067, 6226246.945501015], 
    'Landkreis Freyung-Grafenau':[1471677.4656726774, 6250977.333882196],
    'Landkreis Landshut':[ 1345299.8417824276, 6225086.573713192],
    'Landkreis Passau':[ 1467487.0407486067, 6226246.945501015],
    'Landkreis Regen':[ 1446534.9220135796, 6208898.949195671 ],
    'Landkreis Rottal-Inn':[ 1441261.8130159108, 6195469.92512347 ],
    'Landkreis Straubing-Bogen':[ 1399431.6492868455, 6210429.682062456],
    'Landkreis Dingolfing':[ 1387487.0407486067, 6226246.945501015 ]
  },

/*   orderPoints : new Array(
  'Stadt Landshut',
  'Stadt Passau',
  'Stadt Straubing',
  'Landkreis Deggendorf', 
  'Landkreis Freyung-Grafenau',
  'Landkreis Landshut',
  'Landkreis Passau',
  'Landkreis Regen',
  'Landkreis Rottal-Inn',
  'Landkreis Straubing-Bogen',
  'Landkreis Dingolfing'), */
  

	vectorFeatureArray: new Array(),
	pointid:0, 
	clickedPointid:0,

	rgbList:{},


	createNewPointList:function(){
	map.addLayer(this.pointmaplayer);
						pointmapopen=true;
				}
			
	, 
	setNewPoint:function(coord, name){
		//this.pointid++;
			
		var iconFeature = new Feature({
			  geometry: new Point(coord)
			});
			iconFeature.set('name', name);
			//iconFeature.set('pointid', this.pointid);
		iconFeature.setStyle(function(){
		
		
		return[new Style({
				image: 
        new Icon({
          anchor: [
            -0.1,
            1.0
          ],
          scale: 0.8,
          src: './data/png/PieCharts/' + name +'.png'
        })


			  })
      ]});
		//(this.pointmaplayer).getSource().addFeature(iconFeature);
		
	


		(this.vectorFeatureArray).push(iconFeature);
	
	}, 
	initializeFeatures:function(){
    Object.entries(this.pointCoordinates).forEach(entry => {
      let [key, value] = entry;
      this.setNewPoint(value, key);
    });

 /*    this.orderPoints.forEach(function(item, index){

      let value=this.pointCoordinates[item];
      let key=item;
      this.setNewPoint(value, key);
    }); */

	}

	});

  map.addLayer(pointmap.pointmaplayer);
  pointmap.initializeFeatures();

